import styled, { css } from "styled-components";
import { borderRadius, color, onHover } from "@m/alchemy-theme";
import { NakedButton } from "../naked-button/NakedButton";
import { ArrowDownIcon } from "../icons/ArrowDownIcon";
export const DropdownArrow = styled(ArrowDownIcon) ``;
export const toolbarButtonStyles = css `
  border-radius: ${borderRadius("extraExtraLarge")};
  height: 32px;
  margin: 0;
  min-width: 32px;
  border: 1px solid transparent;
  transition: all 0.15s ease-in-out;
  cursor: ${({ disabled }) => (disabled ? `not-allowed` : `pointer`)};
  color: ${color("base", { palette: "structural" })};
  position: relative;

  &:disabled,
  &[aria-disabled="true"] {
    cursor: not-allowed;

    > svg {
      opacity: 0.3;
    }
  }

  ${(props) => props.isActive
    ? css `
          background: ${color("hint", { palette: "interactiveConstructive" })};
          color: ${color("base", { palette: "interactiveConstructive" })};
          border-color: ${color("highlight", { palette: "interactiveConstructive" })};
        `
    : onHover(css `
            background-color: ${color("hint", { palette: "interactiveConstructive", opacity: 0.5 })};
            color: ${color("base", { palette: "interactiveConstructive" })};
            border-color: ${color("highlight", { palette: "interactiveConstructive", opacity: 0.75 })};
          `, { includeActive: true })}
`;
export const ToolbarButton = styled(NakedButton) `
  ${toolbarButtonStyles};
`;
export const ToolbarLinkButton = styled.a `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${toolbarButtonStyles};
`;
